import { render, staticRenderFns } from "./FormsRequestForm.vue?vue&type=template&id=58ac9c7a&lang=pug&"
import script from "./FormsRequestForm.vue?vue&type=script&lang=js&"
export * from "./FormsRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports